export class PortalGeneralSetting {
  id: number = -1;
  name: string = '';
  value: string = '';
  isPortalConstant: boolean = true;

  constructor() {
  }
}
